import React from 'react';
import { SystemText } from '@salesperformanceint/e4shared';
import { Link } from 'react-router-dom';
import BlobImage from 'components/blobImage';
import Bullet from 'components/prism/bullet';
import ProgressBar from '../progressBar';
import { pathwayStatuses } from 'helpers/pathway';

export const Pathway = ({ item, onClick, padBottom, managerView }) => {
    //console.log('item', item);
    const contents = (
        <>
            <div className="prism-banner-float flex flex-center">
                <Bullet type="pathway" />
                <div className="flex-grow text-right"></div>
            </div>
            <div className="prism-banner">
                {item.image ? (
                    <BlobImage src={item.image} folder="pathway_Image" noholder />
                ) : (
                    <img src="/dist/img/defaults/pathway-default.jpg" />
                )}
            </div>
            <div className="prism-content flex flex-column">
                {item.progress < 100 && <ProgressBar progress={item.progress} />}
                <h3>{item.name}</h3>
                <div className="flex-grow">{item.description && <p className="truncate-4">{item.description}</p>}</div>
                {!item.completed && !managerView && (
                    <div>
                        <button className="btn btn-primary mb10">
                            {item.progress ? SystemText('Welcome/Pathway/Resume') : SystemText('Welcome/Pathway/Start')}
                        </button>
                    </div>
                )}
                <div className="split-col">
                    <Bullet isDueDate={!managerView} isDate={managerView} value={item.due} />
                    {item.status === pathwayStatuses.completed ? (
                        <Bullet isStatus value="completed" />
                    ) : (
                        item.duration > 0 && <Bullet isDuration value={item.duration / 60} />
                    )}
                </div>
            </div>
        </>
    );

    if (onClick) {
        return (
            <a
                key={`pathway-${item.id}`}
                onClick={onClick}
                className={`prism-content-box anchor-top ${padBottom ? 'mb10' : ''}`}
            >
                {contents}
            </a>
        );
    }

    return (
        <Link
            key={`pathway-${item.id}`}
            to={`/pathway/${item.id}`}
            className={`prism-content-box anchor-top ${padBottom ? 'mb10' : ''}`}
        >
            {contents}
        </Link>
    );
};

export default Pathway;
